import React, { useMemo } from 'react';

import UtilityCard from '../UtilityCard';
import Decorator from '../../Decorator';
import StarRating from '../../CardElements/StarRating';
import IconRow from '../../CardElements/IconRow';
import MapRow from '../../CardElements/MapRow';

import rowIcon from '../../../public/images/CardElements/Receipt-Blue.png';

import styles from './MapPlusButton.module.scss';

const { 'card-body': cardBodyClass, 'card-header': cardHeaderClass } = styles;

const MapPlusButton = props => {
  const {
    decoratorCopy,
    title,
    rating,
    clickableRowCopy,
    clickableRowAction = () => {},
    hideClickableRow = false,
    locationAddress,
    isSelected = false,
    buttonCopy,
    handleButtonClick = () => {}
  } = props;

  const { buttonColor, buttonBorder } = useMemo(() => {
    const buttonColor = isSelected ? 'everdays-blue' : 'white';
    const buttonBorder = isSelected ? '' : 'border-black';
    return { buttonColor, buttonBorder };
  }, [isSelected]);

  return (
    <UtilityCard {...{ handleButtonClick, buttonColor, buttonBorder, buttonCopy }}>
      <div className={cardBodyClass}>
        <div className={cardHeaderClass}>
          {decoratorCopy && <Decorator copy={decoratorCopy} />}
          <h1>{title}</h1>
          {rating !== null && rating !== 0 && <StarRating {...{ rating }} />}
        </div>
        {!hideClickableRow && (
          <IconRow icon={rowIcon} rowText={clickableRowCopy} onClick={clickableRowAction} />
        )}
        <MapRow address={locationAddress} />
      </div>
    </UtilityCard>
  );
};

export default MapPlusButton;
